import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const AuthUpdate = () => {
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { user, updatePassword } = useAuth();

  React.useEffect(() => {
    if (!user) {
      console.debug("[AuthUpdate] User not found. Redirecting to Auth page.");
      navigate("/auth");
    }
  }, [user, navigate]);

  const handleUpdatePassword = (e) => {
    e.preventDefault();
    setIsLoading(true);

    updatePassword(password)
      .then(() => {
        toast.success("Password updated successfully!");
        navigate("/auth/callback");
      })
      .catch((error) => {
        console.error("[AuthUpdate] Password update failed:", {
          error,
          name: error.name,
          message: error.message,
          stack: error.stack,
        });
        toast.error(
          "Password update falied. Please try again or contact support!"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (!user) {
    return null;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md">
        <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <div className="flex items-center mb-6">
            <img
              src="/logo_dark.png"
              alt="Paribus AI Logo"
              className="h-8 mr-4"
            />
            <h1 className="text-2xl font-bold text-green-800">
              Update Password
            </h1>
          </div>
          <form onSubmit={handleUpdatePassword}>
            <div className="mb-4">
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-500 leading-tight bg-gray-100"
                type="email"
                value={user.email}
                disabled
              />
            </div>
            <div className="mb-6">
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                type="password"
                placeholder="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="flex items-center justify-between mb-6">
              <button
                className={`bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ${
                  isLoading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? "Processing..." : "Update Password"}
              </button>
              <button
                onClick={() => navigate("/")}
                className="inline-block align-baseline font-bold text-sm text-green-500 hover:text-green-800"
                type="button"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AuthUpdate;
